module.exports = __webpack_public_path__ + "static/media/francoise_rosen_-_blue_pentagon.2dda6d45.wav";